import { render, staticRenderFns } from "./EchartAndTable.vue?vue&type=template&id=4b55d842&scoped=true&"
import script from "./EchartAndTable.vue?vue&type=script&lang=js&"
export * from "./EchartAndTable.vue?vue&type=script&lang=js&"
import style0 from "./EchartAndTable.vue?vue&type=style&index=0&id=4b55d842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b55d842",
  null
  
)

export default component.exports